"use client";

import { useSyncExternalStore } from "react";
import { usePostHog } from "posthog-js/react";
import { sanitizePostHogId } from "@/utils/tracking/posthogId";

/** Re-render auth forms when the idle-initialized SDK has a real browser ID. */
export function usePostHogDistinctId(): string {
  const posthog = usePostHog();
  return useSyncExternalStore(
    (listener) => {
      window.addEventListener("guestgallery:posthog-loaded", listener);
      return () => window.removeEventListener("guestgallery:posthog-loaded", listener);
    },
    () => posthog?.__loaded ? sanitizePostHogId(posthog.get_distinct_id()) : "",
    () => "",
  );
}
